import {
  C_CURRENCY,
  O_CURRENCY
} from "@/src-refactor/modules/shared/model/const/currency.conts";
import { C_BUSINESS_TYPE_ID } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

const prepareBudgedToClient = (res: IPropertyDetailsResponse) => {
  const budge: {
    sale_price: string;
    sale_currency: I_GENERIC_ITEMS[];
    rent_price: string;
    rent_currency: I_GENERIC_ITEMS[];
  } = {
    sale_price: "",
    sale_currency: [C_CURRENCY.RD],
    rent_price: "",
    rent_currency: [C_CURRENCY.RD]
  };

  if (
    [
      C_BUSINESS_TYPE_ID.SALE,
      C_BUSINESS_TYPE_ID.SALE_FURNISHED,
      C_BUSINESS_TYPE_ID.WHITE_LINE_SALES
    ].includes(res?.businesstype_id)
  ) {
    if (res?.price) {
      budge.sale_price = res?.price;
      budge.sale_currency = res?.currency_id
        ? [O_CURRENCY[res?.currency_id]]
        : [C_CURRENCY.RD];
    }
  }

  if (
    [
      C_BUSINESS_TYPE_ID.RENT,
      C_BUSINESS_TYPE_ID.RENT_FURNISHED,
      C_BUSINESS_TYPE_ID.WHITE_LINE_RENTAL
    ].includes(res?.businesstype_id)
  ) {
    if (res?.price) {
      budge.rent_price = res?.price;
      budge.rent_currency = res?.currency_id
        ? [O_CURRENCY[res?.currency_id]]
        : [C_CURRENCY.RD];
    }
  }

  if (
    [
      C_BUSINESS_TYPE_ID.SALE_AND_RENT,
      C_BUSINESS_TYPE_ID.SALE_AND_RENTAL_OF_WHITE_GOODS,
      C_BUSINESS_TYPE_ID.SALE_AND_FURNISHED_RENTAL
    ].includes(res?.businesstype_id)
  ) {
    budge.sale_price = res?.price;
    budge.sale_currency = res?.currency_id
      ? [O_CURRENCY[res?.currency_id]]
      : [C_CURRENCY.RD];
    budge.rent_price = res?.alternate_price;
    budge.rent_currency = res?.currency_alternate_id
      ? [O_CURRENCY[res?.currency_alternate_id]]
      : [C_CURRENCY.RD];
  }
  return budge;
};

export default prepareBudgedToClient;
